export default "__VITE_ASSET__wT36faPW__"